// extracted by mini-css-extract-plugin
export default {"nameInfoWithImg":"style_nameInfoWithImg__6dShZ","coverContainer":"style_coverContainer__E6FuM"};